angular.module('angus.directives').directive('tmsDailyLevels', [ function () {
    return {
        scope: {
            closeCb: '=',
            actionModel: '=',
            windowId: '='

        },
        controller: function ($scope) {
            $scope.dealerId =  $scope.settings ? $scope.settings.hierarchyNodeId : false;
            $scope.searchTerm    = $scope.actionModel.searchTerm || null;
            $scope.monitor    = $scope.actionModel.monitor || null;
            $scope.close = function () {
                if ($scope.modalClosedCb) $scope.modalClosedCb();
                if ($scope.closeCb) $scope.closeCb();
            };


        },
        templateUrl: 'templates/widgets/tmsDailyLevels/html/actionViews/tmsDailyLevelsActionView.html',
        // link: function (scope, element) {
        //     if(element.data('isAdmin')) scope.actionModel.isAdmin = true;
        // }
    };
}]);
